(function () {
  function initGallery(root) {
    var track = root.querySelector('[data-tl-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-tl-thumb]'));
    var current = root.querySelector('[data-tl-current]');
    function setActive(i) {
      thumbs.forEach(function (t, n) {
        if (n === i) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      if (current) current.textContent = String(i + 1);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-tl-thumb'), 10);
        var s = slides[i];
        if (!s) return;
        track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6) setActive(slides.indexOf(e.target));
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
    });
    var dialog = root.querySelector('[data-tl-lightbox]');
    var dImg = root.querySelector('[data-tl-lightbox-img]');
    if (dialog && dImg && typeof dialog.showModal === 'function') {
      root.querySelectorAll('[data-tl-zoom]').forEach(function (b) {
        b.addEventListener('click', function () {
          dImg.src = b.getAttribute('data-tl-zoom');
          dImg.alt = b.getAttribute('data-alt') || '';
          dialog.showModal();
        });
      });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }
  }

  function initBuy() {
    var main = document.querySelector('[data-tl-main-buy]');
    document.querySelectorAll('[data-tl-buy-proxy]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!main || main.disabled || main.getAttribute('aria-disabled') === 'true') return;
        e.preventDefault();
        main.click();
      });
    });
    var bar = document.querySelector('[data-tl-sticky]');
    // TL-CONVERSION 2026-10-22: price-on-request PDPs have no add-to-cart button, so anchor the sticky bar on the POR quote button.
    var anchor = main || document.querySelector('[data-tl-por] .tl-por__cta');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var formVisible = false;
    var ctaVisible = false;
    var ticking = false;
    function update() {
      ticking = false;
      var r = anchor.getBoundingClientRect();
      // show whenever the hero CTA is off-screen (above OR below the viewport, e.g. on load on mobile), unless the bottom CTA or the inline quote form is visible
      var show = (r.bottom < 0 || r.top > window.innerHeight) && !ctaVisible && !formVisible;
      bar.hidden = !show;
      document.documentElement.classList.toggle('tl-att-sticky-on', show);
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    var qf = document.querySelector('#tl-att-quote');
    if (qf) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { formVisible = e.isIntersecting; });
        update();
      }).observe(qf);
    }
    var cta = document.querySelector('[data-tl-cta]');
    if (cta) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { ctaVisible = e.isIntersecting; });
        update();
      }).observe(cta);
    }
    update();
  }

  function init() {
    document.querySelectorAll('[data-tl-gallery]').forEach(initGallery);
    initBuy();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
